import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class FitupService {
  public strapiDataSubject = new BehaviorSubject<any>(null);
  private readonly _url: string = environment.apiUrl

  constructor(private http: HttpClient) {
    this.fetchStrapiData();
  }
  fetchStrapiData(): void {
    this.http.get<any>(this._url).subscribe(data => {
      const localStorageData = this.getDataFromLocalStorage();
      if (!this.areEqual(data, localStorageData)) {
        this.updateLocalStorage(data);
        this.strapiDataSubject.next(data);
      }
    });
  }
  getStrapiDataObservable() {
    return this.strapiDataSubject.asObservable();
  }

  updateLocalStorage(data: any): void {
    if (data) {
      localStorage.setItem('strapi', JSON.stringify(data));
    }
  }
  getDataFromLocalStorage(): any {
    const localStorageItem = localStorage.getItem('strapi');
    return localStorageItem ? JSON.parse(localStorageItem) : null;
  }

  getComponentData(componentName: string) {
    const localStorageData = this.getDataFromLocalStorage();
    if (localStorageData && localStorageData.data && localStorageData.data.attributes) {
      return localStorageData.data.attributes[componentName];
    }
    return null;
  }

  private areEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
}
